module.exports = __webpack_public_path__ + "static/img/why.a0e9367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/why.png
// module id = KdUv
// module chunks = 171